const attrs = {
  name: "",
  updated_at: "",
  links: [],
  history: [],
  sets: []
};

const options = {
  parentType: "spaces",
  parentKey: "space_id"
};

export default {
  generic: {
    attrs,
    options
  }
};
